





























































































































































































































































import { Component, Prop } from 'vue-property-decorator';
import {
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxPopup,
    DxForm,
    DxLookup,
} from 'devextreme-vue/data-grid';
import { DxItem } from 'devextreme-vue/form';
import DataSource from 'devextreme/data/data_source';
import {
    Table,
    TableConfig,
    defaultTableConfig,
    removeItemsFromView,
    columnTemplates,
} from '@/core/components/table';
import {
    CONTRACTS,
    WindowsServiceContract,
    FetchServiceContract,
} from '@/core/contracts';
import { Inject } from '@/core/helpers/vue-inversify-decorator';
import { Vehicle } from '@/dto';
import { ContextsState } from '@/store';
import { localize } from '@/core/filters';
import DevExpress from 'devextreme/bundles/dx.all';
import {
    DxRequiredRule,
    DxCustomRule,
    DxValidator,
} from 'devextreme-vue/validator';
import Validators from '@/core/helpers/validators';
import { ResourceTypeTree, Site, ActivitySchedule } from '@/dto';
import { getParentId } from '@/core/components/tree/treeHelpers';
import TreeDropDown from '@/core/components/controls/TreeDropDown.vue';

@Component({
    components: {
        DxDataGrid,
        DxColumn,
        DxEditing,
        DxPopup,
        DxForm,
        DxItem,
        DxRequiredRule,
        DxCustomRule,
        DxLookup,
        TreeDropDown,
        DxValidator,
    },
})
export default class VehiclesListTable extends Validators {
    @Prop({ type: String, required: true }) public tableKey!: string;
    @Prop({ type: Object, required: true }) public dataSource!: DataSource;
    @Prop({ type: Array, required: true }) public resourceTypes!: any[];
    @Prop({ type: Array, required: true }) public sites!: Site[];
    @Prop({ type: Array, required: true })
    public activityShedules!: ActivitySchedule[];

    @Inject(CONTRACTS.WindowsService)
    private _windowsService?: WindowsServiceContract;
    @Inject(CONTRACTS.FetchService)
    private _fetchService?: FetchServiceContract;

    public get tableConfig(): Partial<TableConfig> {
        return {
            ...defaultTableConfig(this),
        };
    }

    public initRow(e: any) {
        e.data.allowEmptyRelocation =
            e.data.allowEmptyRelocation !== null &&
            e.data.allowEmptyRelocation !== undefined
                ? e.data.allowEmptyRelocation
                : true;
        e.data.isActive =
            e.data.isActive !== null && e.data.isActive !== undefined
                ? e.data.isActive
                : true;
    }

    public async mounted() {
        // raise instance of the table up to parent
        this.$emit('setTableInstance', this.tableInstance);
    }

    public get tableInstance(): Table {
        const element = this.$refs['data-grid'] as unknown;
        return (element as DxDataGrid).instance!;
    }

    public get columnTemplates() {
        return columnTemplates;
    }

    public get localize() {
        return localize;
    }

    public getDataGridInstance(): Table {
        const element = this.$refs['data-grid'] as unknown;
        return (element as DxDataGrid).instance!;
    }

    private get localizePlaceholder() {
        return localize('PlaceholderAny');
    }

    public deleteVehicle() {
        this._windowsService!.showDialog(
            localize('VehicleSimpleDeleteMessage'),
            [
                { id: 1, caption: localize('DialogYes') },
                { id: 2, caption: localize('DialogCancel') },
            ]
        ).then(id => {
            if (id === 1) {
                const vehicle = this.tableInstance.getSelectedRowsData()[0];
                const data = {
                    Vehicles_Partial: [
                        {
                            id: vehicle.id,
                            IsDeleted: true,
                        },
                    ],
                };
                const currentContextId = ContextsState.currentContextId;
                const url = `/files/contexts/${currentContextId}?ignoreWarnings=true`;
                this._fetchService!.post<Vehicle>(
                    url,
                    JSON.stringify(data)
                ).then(() => this.getDataGridInstance().refresh());
            }
        });
    }

    private getloadHandler(): (parameters: any) => Promise<any[]> {
        return (parameters: any) => {
            return this.load(parameters);
        };
    }

    private get treeDropDown(): TreeDropDown {
        const name = 'tree-drop-down';
        return this.$refs[name] as TreeDropDown;
    }

    private validateDropDown() {
        return this.treeDropDown ? this.treeDropDown.validateInput() : null;
    }

    private async load(parameters: any) {
        const currentContextId = ContextsState.currentContextId;
        const parentId =
            parameters && parameters.filter
                ? getParentId(parameters.filter)
                : '';
        const url = `/contexts/${currentContextId}/resourceTypesList/${parentId}`;
        return await this._fetchService!.get<ResourceTypeTree[]>(url);
    }

    private getloadSelectedItemsHandler(): (items: any) => Promise<any[]> {
        return (items: any) => {
            return this.loadSelectedItems(items);
        };
    }

    private async loadSelectedItems(items: any) {
        const currentContextId = ContextsState.currentContextId;
        const url = `/contexts/${currentContextId}/resourceTypesList/selected/${items}`;
        const data = await this._fetchService!.get<ResourceTypeTree[]>(url);

        return data;
    }

    private itemsArrayToString(items: any) {
        if (!items) {
            return '';
        }
        return typeof items === 'string' ? items : items.join(',');
    }
}
